import app from '../app';

export function trackPage({ reportType, source, pageName, pageInTime = undefined, target1 }) {
  if (!pageName) {
    return
  }
  
  trackApi({
    source,
    reportType,
    pageOrEventCode: pageName,
    targetIdOne: target1,
    pageInTime,
  })
}

export function trackEvent({ eventName, source, target1, target2 }) {
  if (!eventName) {
    return
  }
  
  trackApi({
    source,
    reportType: 2,
    pageOrEventCode: eventName,
    targetIdOne: target1,
    targetIdTwo: target2,
  })
}

export function trackPageFromShare({ pageName, source, target1 }) {
  if (!pageName) {
    return
  }
  
  trackApi({
    source,
    reportType: 3,
    pageOrEventCode: pageName,
    targetIdOne: target1,
  })
}

function trackApi({ reportType, pageOrEventCode, targetIdOne, targetIdTwo, pageInTime = undefined, source }) {
  app.fetchAPI({
    url: '/sfapi/initbiapi/pageuser',
    method: 'POST',
    data: {
      reportType,
      pageOrEventCode,
      targetIdOne,
      targetIdTwo,
      source,
      pageStartTime: pageInTime,
    }
  })
}